/* Touché · Motor del buscador inteligente (v2)
   --------------------------------------------
   Recibe lo que escribe la clienta y el índice del catálogo publicado
   (lo arma Liquid desde los productos reales en cada visita) y devuelve
   los productos que cumplen TODO lo pedido, en orden de relevancia.

   Qué entiende, combinado y en cualquier orden:
   - Marca (con apodos: LV, YSL, Dior, Miumiu…; la marca nueva funciona sola).
   - Modelo (se aprende de la ficha "Modelo" y del título; nada cargado a mano).
   - Categoría (tipo de producto, encabezado de la descripción y palabras del
     título: neceser, mochila, hobo, valija, gorra…).
   - Material, textura, estampado, acabado y detalles (ficha "Diseño", título,
     metacampo de material y etiquetas). Nunca el texto libre de la descripción.
   - Color (ficha "Color" y título) y herrajes (ficha "Herrajes").
   - Tamaño (ficha "Tamaño", BB/PM/MM/GM, mini, chico, mediano, grande…).
   - Disponibilidad (en stock / a pedido), novedades, ofertas y colecciones.

   Reglas:
   - Todas las palabras reconocidas se cumplen a la vez (Y, no O).
   - Lo único fijo es el diccionario de idioma (sinónimos en español e inglés,
     plurales, apodos de marca). Marcas, modelos, colores y diseños nuevos se
     aprenden solos del catálogo.
   - La corrección de errores solo toca palabras que no existen en el
     catálogo: 1 letra hasta 8 letras (2 desde 9), misma primera letra y un
     único significado posible. Si hay dudas, no adivina.
   - Si nada cumple todo, ofrece la alternativa más cercana y lo dice
     ("No hay … Te mostramos …"). Nunca mezcla una marca entera.
*/
(function (root) {
  'use strict';

  /* ---------- Diccionario de idioma ---------- */

  /* Apodos de marca. El grupo vale para el proveedor (vendor) cuyo nombre
     normalizado esté en el grupo. Las marcas que no figuran acá funcionan
     solas con su nombre (junto o separado) y con el nombre de la ficha
     "Referencia" si es distinto (por ejemplo "Valentino Garavani"). */
  var APODOS_MARCA = [
    ['louis vuitton', 'lv', 'vuitton', 'luis vuitton', 'louis viton'],
    ['ysaint laurent', 'saint laurent', 'yves saint laurent', 'ysl', 'yves saint', 'saint lauren'],
    ['christian dior', 'dior'],
    ['hermes'],
    ['dolce gabbana', 'dolce', 'gabbana', 'd g', 'dyg', 'd y g', 'dg'],
    ['bottega veneta', 'bottega', 'bv'],
    ['zadig voltaire', 'zadig', 'z v', 'zyv', 'zv'],
    ['miu miu'],
    ['ray ban'],
    ['marc jacobs', 'jacobs', 'mj'],
    ['carolina herrera', 'herrera'],
    ['tom ford']
  ];

  /* Palabras que no aportan. */
  var VACIAS = 'de del la las el los lo y e a con para en un una unos unas al por le the of mas modelo modelos original originales mujer mujeres dama damas color tono talle tamano medida estilo tipo que quiero busco buscar ver todo todos todas otro otra';

  /* Tipos de producto que son carteras o bolsos. */
  var BOLSOS = ['carteras de hombro', 'bandoleras', 'totes y shopper', 'hobo y bucket', 'mini bags', 'clutch y noche', 'mochilas', 'viaje', 'bolso'];

  /* Conceptos. q: lo que puede escribir la clienta (frases separadas por |).
     reglas: el producto cumple si cumple alguna regla.
       tipos: tipo de producto · p: palabras en el campo · campo: dónde mirar
       sinP: palabras que lo excluyen · col: parte del nombre de una colección
     requiere / excluye: otro concepto que el producto debe (o no) cumplir.
     Campos: cat = tipo, encabezado, título y modelo · dis = diseño, título,
     material, etiquetas y color · col = color y título · tam = tamaño, título,
     modelo y variantes · her = herrajes. */
  var C = [];
  function c(id, clase, sub, q, reglas, extra) {
    var o = { id: id, clase: clase, sub: sub, q: q, reglas: reglas };
    if (extra) for (var k in extra) o[k] = extra[k];
    C.push(o);
  }
  // Categorías
  c('bolso', 'categoria', 'tipo', 'cartera|bolso|bolsa|bag|bags|handbag|purse|carterita', [{ tipos: BOLSOS }], { excluye: 'valija' });
  c('hombro', 'categoria', 'tipo', 'de hombro|hombro|shoulder|shoulder bag|al hombro', [{ tipos: ['carteras de hombro'] }, { p: 'de hombro|shoulder' }]);
  c('bandolera', 'categoria', 'tipo', 'bandolera|crossbody|cross body|cruzada|cruzado|messenger|mensajero|slingbag|sling bag|de costado', [{ tipos: ['bandoleras'] }, { p: 'bandolera|crossbody|messenger|slingbag' }]);
  c('tote', 'categoria', 'tipo', 'tote|shopper|shopping|shopping bag|cabas|tote bag', [{ tipos: ['totes y shopper'] }, { p: 'tote|shopper|shopping|cabas' }]);
  c('hobo', 'categoria', 'tipo', 'hobo', [{ p: 'hobo' }, { tipos: ['hobo y bucket'], sinP: 'bucket' }]);
  c('bucket', 'categoria', 'tipo', 'bucket|bucket bag|balde|bolso balde', [{ p: 'bucket' }, { tipos: ['hobo y bucket'], sinP: 'hobo' }], { requiere: 'bolso' });
  c('clutch', 'categoria', 'tipo', 'clutch|de noche|cartera de noche|de fiesta|fiesta|noche|minaudiere', [{ tipos: ['clutch y noche'] }, { p: 'clutch' }]);
  c('mochila', 'categoria', 'tipo', 'mochila|backpack|morral', [{ tipos: ['mochilas'] }, { p: 'mochila|backpack' }]);
  c('viaje', 'categoria', 'tipo', 'viaje|travel|de viaje|equipaje|para viajar', [{ tipos: ['viaje'] }]);
  c('bolsoviaje', 'categoria', 'tipo', 'bolso de viaje|bolso viajero|duffle|duffel|weekender|travel bag|bolso deportivo', [{ tipos: ['viaje'] }, { p: 'bolso de viaje|duffle|duffel' }], { excluye: 'valija' });
  c('valija', 'categoria', 'tipo', 'valija|maleta|trolley|carry on|carryon|cabina|cabin|set de valijas|equipaje de mano|suitcase', [{ p: 'valija|rolling trunk|cabin|check in|piezas', tipos: ['viaje', ''] }]);
  c('neceser', 'categoria', 'tipo', 'neceser|necesser|nesecer|necessaire|cosmetiquera|cosmetic bag|toilet pouch|porta cosmeticos|portacosmeticos|bolso de maquillaje|neceser de viaje', [{ p: 'neceser|necessaire|toilet pouch|trousse|vanity|cosmetiquera' }]);
  c('pochette', 'categoria', 'tipo', 'pochette', [{ p: 'pochette' }]);
  c('rinonera', 'categoria', 'tipo', 'rinonera|belt bag|bumbag|bum bag|cangurera|canguro|fanny pack|waist bag', [{ p: 'rinonera|belt bag|bumbag' }]);
  c('billetera', 'categoria', 'tipo', 'billetera|wallet|monedero|tarjetero|porta tarjetas|portatarjetas|money clip|clip para billetes|billetero', [{ tipos: ['billeteras'] }, { p: 'wallet|billetera|money clip|clip para billetes' }]);
  c('lentes', 'categoria', 'tipo', 'lentes|anteojos|gafas|lentes de sol|anteojos de sol|gafas de sol|sunglasses|glasses|antiparras', [{ tipos: ['lentes'] }, { p: 'anteojos|sunglasses' }]);
  c('reloj', 'categoria', 'tipo', 'reloj|watch|watches', [{ tipos: ['relojes'] }, { p: 'reloj' }]);
  c('calzado', 'categoria', 'tipo', 'calzado|zapatos|zapato|shoes|shoe', [{ tipos: ['calzado'] }]);
  c('zapatillas', 'categoria', 'tipo', 'zapatillas|sneakers|sneaker|trainers|trainer|tenis|deportivas', [{ p: 'zapatillas|sneaker|trainer|skate' }]);
  c('sandalias', 'categoria', 'tipo', 'sandalias|sandals|ojotas|chinelas', [{ p: 'sandalias|sandals' }]);
  c('gorra', 'categoria', 'tipo', 'gorra|cap|caps|casquette|gorra de beisbol|baseball cap|jockey', [{ p: 'gorra' }, { p: 'cap|casquette', tipos: ['accesorios'] }]);
  c('visera', 'categoria', 'tipo', 'visera|vicera|visor', [{ p: 'visera|vicera|visor' }]);
  c('gorro', 'categoria', 'tipo', 'gorro|beanie|gorro de lana', [{ p: 'gorro|beanie' }]);
  c('piluso', 'categoria', 'tipo', 'piluso|bucket hat|sombrero de pescador|pescador', [{ p: 'piluso|bucket hat' }]);
  c('sombrero', 'categoria', 'tipo', 'sombrero|hat|hats', [{ p: 'sombrero|hat|piluso' }]);
  c('bufanda', 'categoria', 'tipo', 'bufanda|scarf|panuelo|pashmina', [{ p: 'bufanda|scarf' }]);
  c('guantes', 'categoria', 'tipo', 'guantes|guante|gloves', [{ p: 'guantes|gloves' }]);
  c('paraguas', 'categoria', 'tipo', 'paraguas|umbrella|sombrilla', [{ p: 'paraguas|umbrella' }]);
  c('vaso', 'categoria', 'tipo', 'vaso|vaso termico|termo|tumbler|botella|taza|quencher', [{ p: 'vaso|vaso termico|tumbler|termo' }]);
  c('regalo', 'categoria', 'tipo', 'bolsa de regalo|regalo|packaging|empaque|bolsa regalo|caja de regalo|para regalo|packaging y regalo', [{ tipos: ['bolsas de regalo'] }, { p: 'bolsa de regalo' }]);
  c('accesorio', 'categoria', 'tipo', 'accesorio|accessories', [{ tipos: ['accesorios', 'billeteras', 'lentes', 'calzado', 'relojes'] }]);
  c('hombre', 'categoria', 'tipo', 'hombre|men|masculino|caballero|varon|para hombre|accesorios para hombre|de hombre', [{ col: 'hombre' }]);
  c('set', 'categoria', 'tipo', 'set|conjunto|kit|juego', [{ p: 'set|piezas' }]);
  c('medialuna', 'categoria', 'tipo', 'media luna|medialuna|half moon|halfmoon', [{ p: 'media luna|half moon' }]);
  c('satchel', 'categoria', 'tipo', 'satchel|maletin|portafolio|top handle|asa corta', [{ p: 'satchel|maletin|top handle' }]);
  c('playa', 'categoria', 'tipo', 'playa|de playa|bolso de playa|beach|beach bag', [{ p: 'de playa|playa|beach' }]);
  c('canasto', 'categoria', 'tipo', 'canasto|canasta|cesta|cesto|basket|panier', [{ p: 'basket|panier|bascket|canasto|cesta' }]);
  // Materiales
  c('gamuza', 'diseno', 'material', 'gamuza|gamuzado|suede|ante|antelina|nobuk|nubuck', [{ p: 'gamuza|gamuzado|suede' }]);
  c('cuero', 'diseno', 'material', 'cuero|piel|leather', [{ p: 'cuero|leather|ecocuero|eco cuero|cuero sintetico|sintetico|cuerina|cuero vegano|nappa|napa|taurillon' }]);
  c('ecocuero', 'diseno', 'material', 'ecocuero|eco cuero|cuero sintetico|cuero vegano|cuero ecologico|cuerina|simil cuero|sintetico|vegano', [{ p: 'ecocuero|eco cuero|cuero sintetico|sintetico|cuero vegano|cuerina' }]);
  c('nappa', 'diseno', 'material', 'nappa|napa|cuero nappa|cuero napa', [{ p: 'nappa|napa' }]);
  c('lona', 'diseno', 'material', 'lona|canvas', [{ p: 'lona|canvas' }]);
  c('rafia', 'diseno', 'material', 'rafia|raffia|paja|paja toquilla|de rafia', [{ p: 'rafia|raffia' }, { col: 'rafia' }]);
  c('denim', 'diseno', 'material', 'denim|jean|jeans|de jean|vaquero|mezclilla', [{ p: 'denim|jean|jeans' }]);
  c('nylon', 'diseno', 'material', 'nylon|nailon|nilon|re nylon|renylon', [{ p: 'nylon|nailon' }]);
  c('tela', 'diseno', 'material', 'tela|textil|fabric', [{ p: 'tela|textil|lona|canvas|nylon' }]);
  c('terciopelo', 'diseno', 'material', 'terciopelo|velvet', [{ p: 'terciopelo|velvet' }]);
  c('pelo', 'diseno', 'material', 'pelo|peluche|fur|piel sintetica|eco pelo|teddy|corderito', [{ p: 'fur|pelo|peluche|teddy' }]);
  // Texturas
  c('tejido', 'diseno', 'textura', 'tejido|tejida|woven|knit|tricot|mimbre|wicker|de mimbre|tejido a mano|entrelazado|intrecciato', [{ p: 'tejido|tejida|crochet|trenzado|trenzada|woven|mimbre|intrecciato|knit' }]);
  c('trenzado', 'diseno', 'textura', 'trenzado|trenzada|trenza|braided', [{ p: 'trenzado|trenzada|braided' }]);
  c('crochet', 'diseno', 'textura', 'crochet|croche|ganchillo', [{ p: 'crochet' }]);
  c('cocodrilo', 'diseno', 'textura', 'cocodrilo|croco|crocodile|crocodilo|crocodrilo|crocco|reptil|simil cocodrilo|piel de cocodrilo', [{ p: 'cocodrilo|croco|crocodile|crocodilo|crocodrilo' }]);
  c('matelasse', 'diseno', 'textura', 'matelasse|matelaseado|matelase|acolchado|acolchonado|quilted|capitone|capitoneado|guateado', [{ p: 'matelasse|acolchado|quilted|cannage|capitone|matelaseado' }]);
  c('puffer', 'diseno', 'textura', 'puffer|inflado|puffy|abullonado', [{ p: 'puffer|puffy' }]);
  c('relieve', 'diseno', 'textura', 'relieve|en relieve|embossed|grabado|repujado', [{ p: 'relieve|embossed' }]);
  // Estampados
  c('monograma', 'diseno', 'estampado', 'monograma|monogram|monogramado|logomania', [{ p: 'monograma|monogram|oblique|goyardine|gg supreme' }]);
  c('damier', 'diseno', 'estampado', 'damier|damero|ajedrez', [{ p: 'damier|damero' }]);
  c('cuadros', 'diseno', 'estampado', 'cuadros|a cuadros|cuadrille|check|tartan|escoces|pied de poule', [{ p: 'a cuadros|cuadros|check|tartan|damier|damero' }]);
  c('animalprint', 'diseno', 'estampado', 'animal print|animalprint|print animal|estampado animal|leopardo|leopard|cebra|zebra|jaguar|felino', [{ p: 'animal print|animal|leopardo|leopard|cebra|zebra' }]);
  c('floral', 'diseno', 'estampado', 'floral|flores|flor|flowers|floreado', [{ p: 'floral|flores|flowers|flor' }]);
  c('estampado', 'diseno', 'estampado', 'estampado|estampa|print|printed|con estampa|dibujos', [{ p: 'estampado|floral|flowers|flores|animal print|frutillas|strawberry|print|cerises' }]);
  c('bicolor', 'diseno', 'estampado', 'bicolor|dos colores|dos tonos|combinado', [{ p: 'bicolor' }, { fn: 'combinado' }]);
  c('logo', 'diseno', 'detalle', 'logo|con logo|logotipo', [{ p: 'logo' }]);
  // Acabados
  c('charol', 'diseno', 'acabado', 'charol|charolado|acharolado|patent|patent leather|vinilo', [{ p: 'charol|patent' }]);
  c('metalizado', 'diseno', 'acabado', 'metalizado|metalico|metallic|espejado|mirror|efecto espejo|laminado', [{ p: 'metalizado|metallic|espejado|mirror|laminado' }]);
  c('mate', 'diseno', 'acabado', 'mate|matte|opaco', [{ p: 'mate|matte' }]);
  c('liso', 'diseno', 'acabado', 'liso|plain|sin estampado', [{ p: 'liso' }]);
  // Detalles
  c('bordado', 'diseno', 'detalle', 'bordado|embroidery|embroidered', [{ p: 'bordado|embroidery' }]);
  c('tachas', 'diseno', 'detalle', 'tachas|tacha|tachuelas|tachuela|studs|studded|remaches', [{ p: 'tachas|studs|tachuelas' }]);
  c('flecos', 'diseno', 'detalle', 'flecos|fleco|fringe|fringes|con flecos', [{ p: 'flecos|fringes|fringe' }]);
  c('strass', 'diseno', 'detalle', 'strass|brillos|brillitos|cristales|rhinestones|pedreria|glitter|lentejuelas', [{ p: 'strass|rhinestones|glitter|lentejuelas' }]);
  c('cadena', 'diseno', 'detalle', 'cadena|chain|con cadena|asa de cadena', [{ p: 'cadena|chain' }]);
  c('nudo', 'diseno', 'detalle', 'nudo|knot|nudo doble|double knot', [{ p: 'nudo|knot|nudos' }]);
  // Colores (los que no están acá se aprenden de la ficha "Color")
  function col(id, q, p, extra) { c(id, 'color', 'color', q, [{ p: p, campo: 'col' }], extra); }
  col('negro', 'negro|black|noir', 'negro|black');
  col('blanco', 'blanco|white|blanc', 'blanco|white');
  col('marron', 'marron|brown|cafe', 'marron|brown|cafe|chocolate');
  col('chocolate', 'chocolate', 'chocolate');
  col('camel', 'camel|camello', 'camel');
  col('suela', 'suela|tan', 'suela|tan');
  col('cognac', 'cognac|conac', 'cognac');
  col('caramelo', 'caramelo|caramel', 'caramelo|caramel');
  col('miel', 'miel|honey', 'miel|honey');
  col('beige', 'beige|beis', 'beige');
  col('nude', 'nude|color piel', 'nude');
  col('vison', 'vison|mink|taupe|topo', 'vison|mink|taupe');
  col('crudo', 'crudo|ecru|off white|offwhite', 'crudo|ecru');
  col('natural', 'natural', 'natural');
  col('hueso', 'hueso|bone', 'hueso');
  col('marfil', 'marfil|ivory', 'marfil|ivory');
  col('crema', 'crema|cream|vainilla', 'crema|cream');
  col('rojo', 'rojo|red|colorado|rouge', 'rojo|red');
  col('bordo', 'bordo|bordeaux|burgundy|borravino|vino|granate', 'bordo|bordeaux|burgundy|borravino|granate');
  col('rosa', 'rosa|rosado|pink|rose|rosa palido|rosa viejo', 'rosa|rosado|pink|rose');
  col('fucsia', 'fucsia|fuchsia|fuscia', 'fucsia|fuchsia|fuscia');
  col('magenta', 'magenta', 'magenta');
  col('coral', 'coral', 'coral');
  col('salmon', 'salmon', 'salmon');
  col('violeta', 'violeta|violet|purpura|morado|purple', 'violeta|purpura|purple|morado');
  col('lila', 'lila|lilac', 'lila|lilac');
  col('lavanda', 'lavanda|lavender', 'lavanda|lavender');
  col('azul', 'azul|blue', 'azul|blue|navy');
  col('azulmarino', 'azul marino|marino|navy|azul oscuro', 'azul marino|navy|marino|azul oscuro');
  col('celeste', 'celeste|azul claro|light blue|baby blue|cielo|turquesa', 'celeste|azul claro|light blue');
  col('verde', 'verde|green', 'verde|green');
  col('gris', 'gris|grey|gray|plomo', 'gris|grey|gray');
  col('amarillo', 'amarillo|yellow|mostaza', 'amarillo|yellow');
  col('naranja', 'naranja|orange|anaranjado', 'naranja|orange');
  col('dorado', 'dorado|gold|golden|oro', 'dorado|gold|golden', { metal: true });
  col('plateado', 'plateado|silver|plata', 'plateado|silver', { metal: true });
  col('champagne', 'champagne|champan|shampagne|champana', 'champagne|shampagne');
  col('bronce', 'bronce|bronze', 'bronce|bronze', { metal: true });
  col('cobre', 'cobre|cobrizo|copper', 'cobre|cobrizo|copper', { metal: true });
  col('acerado', 'acerado|acero|steel|gunmetal', 'acerado|acero', { metal: true });
  col('multicolor', 'multicolor|colores|colorido|multi color|arcoiris|arco iris', 'multicolor|colors|arcoiris|murticolor');
  col('transparente', 'transparente|transparent|clear', 'transparente|transparent');
  col('carey', 'carey|tortoise|havana|tortuga', 'carey|tortoise|havana');
  // Tamaños
  c('mini', 'tamano', 'tamano', 'mini|nano|micro', [{ p: 'mini|nano|micro', campo: 'tam' }, { tipos: ['mini bags'] }]);
  c('minibag', 'categoria', 'tipo', 'mini bag|minibag|mini bags|cartera mini|bolso mini', [{ tipos: ['mini bags'] }, { p: 'mini|nano|micro', campo: 'tam' }], { requiere: 'bolso' });
  c('chico', 'tamano', 'tamano', 'chico|pequeno|small|petit|petite', [{ p: 'chico|small|pequeno|pm|petit|petite', campo: 'tam' }]);
  c('mediano', 'tamano', 'tamano', 'mediano|medium', [{ p: 'mediano|medium|mm|m', campo: 'tam' }]);
  c('grande', 'tamano', 'tamano', 'grande|large|big|maxi|xl|xxl|oversize|gigante', [{ p: 'grande|large|big|maxi|xl|gm', campo: 'tam' }]);
  // Disponibilidad y colecciones de la tienda
  c('stock', 'disponibilidad', 'disponibilidad', 'en stock|stock|disponible|entrega inmediata|inmediata|listo para enviar|para enviar|en existencia', [{ fn: 'stock' }]);
  c('pedido', 'disponibilidad', 'disponibilidad', 'a pedido|pedido|por encargo|encargo|bajo pedido|por pedido', [{ fn: 'pedido' }]);
  c('nuevo', 'disponibilidad', 'coleccion', 'nuevo|novedad|novedades|ultimos ingresos|recien llegados|new in|lo nuevo', [{ fn: 'nuevo' }, { col: 'novedades' }]);
  c('oferta', 'disponibilidad', 'coleccion', 'oferta|sale|descuento|promo|promocion|liquidacion|rebaja', [{ col: 'oferta' }]);

  /* Nombre para mostrar en los avisos cuando el proveedor está escrito distinto. */
  var NOMBRE_VISIBLE = { 'ysaint laurent': 'Saint Laurent' };

  var TALLES_LITERALES = { bb: 1, pm: 1, mm: 1, gm: 1, xs: 1, xl: 1, nano: 1 };
  /* Orden en que se resignan palabras cuando nada cumple todo (primero las de arriba). */
  var PRIORIDAD_SOLTAR = { desconocida: 0, texto: 1, color: 2, herraje: 2, disponibilidad: 3, tamano: 3, diseno: 4, categoria: 5, coleccion: 5, modelo: 6 };

  /* ---------- Utilidades ---------- */
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ñ/g, 'n').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function palabras(s) { var n = norm(s); return n ? n.split(' ') : []; }
  var ENTIDADES = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ', ntilde: 'ñ', Ntilde: 'Ñ', aacute: 'á', eacute: 'é', iacute: 'í', oacute: 'ó', uacute: 'ú', Aacute: 'Á', Eacute: 'É', Iacute: 'Í', Oacute: 'Ó', Uacute: 'Ú', uuml: 'ü', egrave: 'è', agrave: 'à', ccedil: 'ç', rsquo: '’', lsquo: '‘', ldquo: '“', rdquo: '”' };
  function texto(s) {
    return String(s || '').replace(/&(#x?[0-9a-f]+|[a-z]+);/gi, function (m, e) {
      if (e[0] === '#') { var n = e[1] === 'x' || e[1] === 'X' ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10); return isNaN(n) ? m : String.fromCharCode(n); }
      return ENTIDADES[e] !== undefined ? ENTIDADES[e] : m;
    }).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* Palabras del diccionario que no cambian de género porque la otra forma es otra cosa
     ("gorra" ≠ "gorro"). Se calcula solo a partir del diccionario. */
  var SIN_GENERO = (function () {
    var due = {}, out = {};
    C.forEach(function (k) { k.q.split('|').forEach(function (x) { x = x.trim(); if (x.indexOf(' ') === -1) due[x] = k.id; }); });
    Object.keys(due).forEach(function (w) {
      var u = w.slice(-1), r = w.slice(0, -1), otra = u === 'o' ? r + 'a' : u === 'a' ? r + 'o' : null;
      if (otra && due[otra] && due[otra] !== due[w]) { out[w] = 1; out[otra] = 1; }
    });
    return out;
  })();

  /* Plurales y femenino/masculino de una palabra. */
  var memoFormas = {};
  function formas(w) {
    if (memoFormas[w]) return memoFormas[w];
    var f = {}; f[w] = 1;
    var raiz = /s$/.test(w) ? w.replace(/e?s$/, '') : w;
    var genero = !SIN_GENERO[w] && !SIN_GENERO[raiz] && !SIN_GENERO[w.slice(0, -1)];
    if (w.length > 2 && !/\d/.test(w)) {
      var u = w.slice(-1), r = w.slice(0, -1);
      if (u === 'o') { f[w + 's'] = 1; if (genero) { f[r + 'a'] = 1; f[r + 'as'] = 1; } }
      else if (u === 'a') { f[w + 's'] = 1; if (genero) { f[r + 'o'] = 1; f[r + 'os'] = 1; } }
      else if (u === 'e' || u === 'i' || u === 'u') f[w + 's'] = 1;
      else if (u === 'z') f[r + 'ces'] = 1;
      else if (u === 's') { /* ya es plural o termina en s */ }
      else f[w + 'es'] = 1;
      // y al revés: de plural/femenino a la forma base
      if (/es$/.test(w) && w.length > 4) f[w.slice(0, -2)] = 1;
      if (/[aeiou]s$/.test(w) && w.length > 3) { var b = w.slice(0, -1); f[b] = 1; if (genero && /a$/.test(b)) f[b.slice(0, -1) + 'o'] = 1; if (genero && /o$/.test(b)) f[b.slice(0, -1) + 'a'] = 1; }
    }
    memoFormas[w] = f;
    return f;
  }
  var memoLista = {};
  function formasLista(w) { return memoLista[w] || (memoLista[w] = Object.keys(formas(w))); }
  function igual(a, b) { return a === b || !!formas(a)[b] || !!formas(b)[a]; }

  /* Texto de un campo preparado para buscar rápido: palabras, sus formas y la lista en orden. */
  function campo(tokens) {
    var tok = {}, fs = {};
    for (var i = 0; i < tokens.length; i++) { var t = tokens[i]; if (!t || tok[t]) continue; tok[t] = 1; var l = formasLista(t); for (var j = 0; j < l.length; j++) fs[l[j]] = 1; }
    return { tok: tok, fs: fs, arr: tokens.filter(Boolean) };
  }
  function tienePalabra(cp, w) {
    if (cp.fs[w] === 1) return true;
    var l = formasLista(w);
    for (var i = 0; i < l.length; i++) if (cp.tok[l[i]] === 1) return true;
    return false;
  }
  /* ¿La frase (lista de palabras) aparece en el campo? */
  function contiene(cp, frase) {
    if (frase.length === 1) return tienePalabra(cp, frase[0]);
    if (!tienePalabra(cp, frase[0])) return false;
    var tokens = cp.arr, n = frase.length;
    for (var i = 0; i + n <= tokens.length; i++) {
      var ok = true;
      for (var j = 0; j < n && ok; j++) ok = igual(tokens[i + j], frase[j]);
      if (ok) return true;
    }
    return false;
  }

  /* Distancia de edición con trasposición, cortando temprano. */
  function distancia(a, b, max) {
    var la = a.length, lb = b.length, i, j;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev2 = null, prev = [], cur, v, minFila;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i]; minFila = i;
      for (j = 1; j <= lb; j++) {
        v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < minFila) minFila = v;
      }
      if (minFila > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }
  function parecida(q, w) {
    if (q.length < 4 || w.length < 4 || q[0] !== w[0] || /\d/.test(q)) return false;
    var tol = q.length >= 9 ? 2 : 1;
    return distancia(q, w, tol) <= tol;
  }

  // Palabras del título que siguen a "Herraje(s)": "… Negro Herrajes Negros" → herrajes negros.
  function despuesDe(l, rx) { for (var i = 0; i < l.length; i++) if (rx.test(l[i])) return l.slice(i + 1); return []; }
  function lista(s) { return s ? String(s).split('|').map(function (x) { return x.trim(); }).filter(Boolean) : []; }

  /* ---------- Índice ---------- */
  function construir(productos) {
    var vacias = {}; VACIAS.split(' ').forEach(function (w) { vacias[w] = 1; });
    var conceptos = C.map(function (k) {
      return {
        id: k.id, clase: k.clase, sub: k.sub, metal: !!k.metal, requiere: k.requiere, excluye: k.excluye,
        q: lista(k.q).map(palabras),
        reglas: k.reglas.map(function (r) {
          return { tipos: r.tipos, p: lista(r.p).map(palabras), campo: r.campo || (k.clase === 'categoria' ? 'cat' : k.clase === 'diseno' ? 'dis' : k.clase === 'color' ? 'col' : 'tam'), sinP: lista(r.sinP).map(palabras), col: r.col, fn: r.fn };
        })
      };
    });
    var porId = {}; conceptos.forEach(function (k) { porId[k.id] = k; });

    // Marcas
    var grupos = APODOS_MARCA.map(function (g) { return { apodos: g.map(palabras), nombre: null, cuenta: 0 }; });
    function grupoDeNombre(v) {
      var nv = norm(v);
      for (var k = 0; k < grupos.length; k++) if (grupos[k].apodos.some(function (a) { return a.join(' ') === nv; })) return grupos[k];
      return null;
    }
    function agregarApodo(g, nombre) {
      var a = palabras(nombre); if (!a.length) return;
      if (!g.apodos.some(function (x) { return x.join(' ') === a.join(' '); })) g.apodos.push(a);
      var junto = a.join('');
      if (a.length > 1 && !g.apodos.some(function (x) { return x.length === 1 && x[0] === junto; })) g.apodos.push([junto]); // "miumiu", "saintlaurent"
    }
    grupos.forEach(function (g) { g.apodos.slice().forEach(function (a) { agregarApodo(g, a.join(' ')); }); });

    var items = [], bigramas = {}, juntas = {}, inicioModelo = {}, vocModelo = {}, vocTexto = {}, vocColorFicha = {}, vocDisenoFicha = {}, formasMostrar = {}, colecciones = {};
    var tiposPorFamilia = {};

    productos.forEach(function (p, idx) {
      var f = {};
      if (p.f) for (var k in p.f) f[texto(k)] = texto(p.f[k]);
      // Compatibilidad con el índice v1
      if (!p.f) { if (p.m) f.Modelo = p.m; if (p.c) f.Color = p.c; if (p.s) f['Diseño'] = p.s; if (p.a) f['Tamaño'] = p.a; }
      var g = grupoDeNombre(p.v);
      if (!g) { g = { apodos: [], nombre: null, cuenta: 0 }; grupos.push(g); agregarApodo(g, p.v); }
      agregarApodo(g, p.v);
      if (f.Referencia && norm(f.Referencia) !== norm(p.v)) agregarApodo(g, f.Referencia);
      g.nombre = g.nombre || p.v; g.cuenta++;

      var tv = palabras(p.v), tt = palabras(p.t), k2 = 0;
      while (k2 < tv.length && tt[k2] === tv[k2]) k2++;
      if (k2 === 0 && f.Referencia) { var tr = palabras(f.Referencia); while (k2 < tr.length && tt[k2] === tr[k2]) k2++; }
      var resto = tt.slice(k2);
      var modelo = palabras(f.Modelo);
      var encabezado = palabras(texto(p.k));
      var tipo = norm(p.y);
      var etiquetas = lista(p.g).map(norm);
      var cols = lista(p.l).map(norm);
      var material = palabras(lista(p.b).join(' '));
      var colorPatron = palabras(lista(p.q).join(' '));
      var opciones = palabras(lista(p.n).join(' '));
      var ficha = { color: palabras(f.Color), diseno: palabras(f['Diseño']), tamano: palabras(f['Tamaño']), herrajes: palabras(f.Herrajes) };
      var otros = [];
      Object.keys(f).forEach(function (r) { if (['Referencia', 'Modelo', 'Color', 'Diseño', 'Tamaño', 'Herrajes'].indexOf(r) === -1) otros = otros.concat(palabras(f[r])); });

      (p.t + ' ' + (f.Modelo || '') + ' ' + (f['Diseño'] || '') + ' ' + (f.Color || '')).split(/\s+/).forEach(function (w) {
        var n = palabras(w); if (n.length === 1 && !formasMostrar[n[0]]) formasMostrar[n[0]] = w.replace(/[(),.;:]/g, '');
      });

      // Textos por campo
      var txt = {
        cat: [tipo].concat(encabezado, resto, modelo).join(' ').split(' '),
        dis: ficha.diseno.concat(resto, modelo, material, etiquetas.join(' ').split(' '), ficha.color, otros, encabezado),
        col: ficha.color.concat(resto, opciones, ficha.color.length || resto.length ? [] : colorPatron),
        tam: ficha.tamano.concat(resto, modelo, opciones),
        her: ficha.herrajes.concat(despuesDe(resto, /^herraje/))
      };
      // Palabras propias del producto (para modelo y texto literal)
      var pal = {};
      function marcar(lst) { lst.forEach(function (w) { if (w) pal[w] = 1; }); }
      marcar(resto); marcar(modelo); marcar(ficha.color); marcar(ficha.diseno); marcar(ficha.tamano); marcar(ficha.herrajes); marcar(otros); marcar(encabezado);
      [resto, modelo].forEach(function (l) {
        for (var i = 0; i + 1 < l.length; i++) {
          var j2 = l[i] + l[i + 1]; if (!pal[j2]) { pal[j2] = 1; juntas[j2] = 1; } // "lou lou" = "loulou"
          if (i + 2 < l.length) { var j3 = j2 + l[i + 2]; if (!pal[j3]) { pal[j3] = 1; juntas[j3] = 1; } } // "on the go" = "onthego"
        }
      });
      var mb = modelo.length ? modelo : resto;
      if (mb.length) inicioModelo[mb[0]] = 1; // "25" en "Chanel 25 Medium" es el modelo; "30" en "Speedy 30" es la medida
      mb.forEach(function (w) { if (!vacias[w]) vocModelo[w] = (vocModelo[w] || 0) + 1; });
      for (var bi = 0; bi + 1 < mb.length; bi++) bigramas[mb[bi] + ' ' + mb[bi + 1]] = 1; // "cap vert", "box suitcase"
      Object.keys(pal).forEach(function (w) { if (!vacias[w]) vocTexto[w] = 1; });
      ficha.color.forEach(function (w) { vocColorFicha[w] = 1; });
      ficha.diseno.forEach(function (w) { vocDisenoFicha[w] = 1; });
      cols.forEach(function (cn) { colecciones[cn] = (colecciones[cn] || 0) + 1; });

      var base = modelo.length ? modelo : resto;
      var familias = [norm(p.v) + '|' + base.slice(0, 2).join(' '), norm(p.v) + '|' + base.slice(0, 1).join(' ')];
      if (tipo) familias.forEach(function (fa) { tiposPorFamilia[fa] = tiposPorFamilia[fa] || {}; tiposPorFamilia[fa][tipo] = (tiposPorFamilia[fa][tipo] || 0) + 1; });

      items.push({
        p: p, idx: idx, grupo: g, titulo: resto, modelo: modelo, ficha: ficha, f: f, txt: txt, palabras: pal, palForm: campo(Object.keys(pal)), tipo: tipo,
        tipoInferido: false, familias: familias, etiquetas: etiquetas, colecciones: cols,
        pedido: norm(p.e).indexOf('pedido') !== -1 || etiquetas.indexOf('a pedido') !== -1,
        nuevo: etiquetas.indexOf('nuevo') !== -1,
        con: {}, conLit: {}
      });
    });

    // Palabras de cada marca (para completar mientras se escribe dentro de la marca: "ysl lou" → Loulou)
    items.forEach(function (it) { var g = it.grupo; g.palabras = g.palabras || {}; for (var w in it.palabras) g.palabras[w] = (g.palabras[w] || 0) + 1; });

    // Productos sin tipo: toman el de su familia (misma marca y modelo), si es claro.
    items.forEach(function (it) {
      if (!it.tipo) {
        for (var q = 0; q < it.familias.length && !it.tipo; q++) {
          var t = tiposPorFamilia[it.familias[q]]; if (!t) continue;
          var ks = Object.keys(t); if (ks.length !== 1) continue;
          it.tipo = ks[0]; it.tipoInferido = true; it.txt.cat = it.tipo.split(' ').concat(it.txt.cat);
        }
      }
      for (var k in it.txt) it.txt[k] = campo(it.txt[k]);
    });

    // Conceptos que cumple cada producto. Índice invertido: palabra → reglas que la usan,
    // así cada producto se recorre una sola vez por sus propias palabras.
    var W = {}, Wex = {};
    function registrar(w, e) {
      (Wex[w] = Wex[w] || []).push(e);
      formasLista(w).forEach(function (x) { (W[x] = W[x] || []).push(e); });
    }
    conceptos.forEach(function (k, ki) {
      k.reglas.forEach(function (r, ri) {
        r.p.forEach(function (fr, fi) { registrar(fr[0], { ki: ki, ri: ri, fr: fr, sin: false, campo: r.campo }); });
        r.sinP.forEach(function (fr, fi) { registrar(fr[0], { ki: ki, ri: ri, fr: fr, sin: true, campo: r.campo }); });
      });
    });
    var CAMPOS = ['cat', 'dis', 'col', 'tam', 'her'];
    items.forEach(function (it) {
      var hitP = {}, hitS = {}, her = {};
      CAMPOS.forEach(function (cn) {
        var cp = it.txt[cn], vistos = {};
        var visitar = function (e) {
          if (e.campo !== cn && !(cn === 'her' && conceptos[e.ki].clase === 'color')) return;
          var clave = e.ki + '|' + e.ri + '|' + e.sin + '|' + e.fr.join(' ');
          if (vistos[clave]) return; vistos[clave] = 1;
          if (e.fr.length > 1 && !contiene(cp, e.fr)) return;
          if (cn === 'her') { if (!e.sin) her[e.ki] = 1; if (e.campo !== 'her') return; }
          (e.sin ? hitS : hitP)[e.ki + '|' + e.ri] = 1;
        };
        for (var t in cp.tok) {
          var l = W[t]; if (l) for (var i = 0; i < l.length; i++) visitar(l[i]);
          var fl = formasLista(t);
          for (var j = 0; j < fl.length; j++) { var l2 = Wex[fl[j]]; if (l2) for (var m = 0; m < l2.length; m++) visitar(l2[m]); }
        }
      });
      var colorF = ' ' + norm(it.f.Color) + ' ';
      conceptos.forEach(function (k, ki) {
        var ok = k.reglas.some(function (r, ri) {
          if (r.tipos && r.tipos.indexOf(it.tipo) === -1) return false;
          if (r.fn === 'stock' && !(it.p.d && !it.pedido)) return false;
          if (r.fn === 'pedido' && !it.pedido) return false;
          if (r.fn === 'nuevo' && !it.nuevo) return false;
          if (r.fn === 'combinado' && !/ y | con /.test(colorF)) return false;
          if (r.col && !it.colecciones.some(function (cn) { return cn.indexOf(r.col) !== -1; })) return false;
          if (r.p.length && !hitP[ki + '|' + ri]) return false;
          if (r.sinP.length && hitS[ki + '|' + ri]) return false;
          return !!(r.tipos || r.p.length || r.fn || r.col);
        });
        if (ok) it.con[k.id] = 1;
        // Metales: también valen los herrajes ("Birkin dorada" = herrajes dorados)
        if (k.clase === 'color' && her[ki]) { it.conHer = it.conHer || {}; it.conHer[k.id] = 1; }
      });
      conceptos.forEach(function (k) {
        if (k.requiere && !it.con[k.requiere]) delete it.con[k.id];
        if (k.excluye && it.con[k.excluye]) delete it.con[k.id];
      });
    });

    // Vocabulario de la clienta: frases del diccionario
    var frases = []; // {pal:[...], concepto}
    conceptos.forEach(function (k) { k.q.forEach(function (fr) { frases.push({ pal: fr, k: k }); }); });
    frases.sort(function (a, b) { return b.pal.length - a.pal.length; });
    var palabraConcepto = {}; // forma → [conceptos] (frases de una palabra)
    frases.forEach(function (fr) {
      if (fr.pal.length !== 1) return;
      Object.keys(formas(fr.pal[0])).forEach(function (w) {
        palabraConcepto[w] = palabraConcepto[w] || [];
        if (palabraConcepto[w].indexOf(fr.k) === -1) palabraConcepto[w].push(fr.k);
      });
    });

    // Colecciones de la tienda que se pueden buscar por nombre ("verano", "ofertas"…)
    var nombresMarca = {}; grupos.forEach(function (g) { g.apodos.forEach(function (a) { nombresMarca[a.join(' ')] = 1; }); });
    var tiposTienda = {}; items.forEach(function (it) { if (it.tipo) tiposTienda[it.tipo] = 1; });
    var genericas = { carteras: 1, productos: 1, coleccion: 1, mas: 1 };
    var colBuscables = [];
    Object.keys(colecciones).forEach(function (cn) {
      if (nombresMarca[cn] || tiposTienda[cn] || /do not delete|inicio|stock cero|ultimate/.test(cn)) return;
      var clave = cn.split(' ').filter(function (w) { return !vacias[w] && !genericas[w]; });
      if (clave.length) colBuscables.push({ nombre: cn, pal: clave });
    });

    items.forEach(function (it) { it.titulo.concat(it.modelo).forEach(function (w) { delete juntas[w]; }); });
    var vocTodo = {};
    Object.keys(vocTexto).forEach(function (w) { vocTodo[w] = 1; });
    Object.keys(palabraConcepto).forEach(function (w) { vocTodo[w] = 1; });

    return {
      items: items, grupos: grupos, conceptos: conceptos, porId: porId, frases: frases, palabraConcepto: palabraConcepto,
      vocModelo: vocModelo, bigramas: bigramas, juntas: juntas, inicioModelo: inicioModelo, vocTexto: vocTexto, vocColorFicha: vocColorFicha, vocDisenoFicha: vocDisenoFicha, vocTodo: vocTodo,
      formas: formasMostrar, colBuscables: colBuscables, vacias: vacias
    };
  }

  /* ---------- Lectura de la consulta ---------- */
  function leer(consulta, ix, opciones) {
    opciones = opciones || {};
    var ws = palabras(consulta);
    var n = ws.length;
    var usada = ws.map(function () { return false; });
    var terminos = [];
    function rango(i, len) { for (var t = 0; t < len; t++) usada[i + t] = true; }
    function libres(i, len) { for (var t = 0; t < len; t++) if (i + t >= n || usada[i + t]) return false; return true; }
    function coincideFrase(i, fr) { for (var t = 0; t < fr.length; t++) if (!igual(ws[i + t], fr[t])) return false; return true; }

    // 1) Marca: el apodo más largo primero; tolera un error en palabras que no existen en el catálogo.
    var marca = null, viaMarca = null;
    var cands = [];
    ix.grupos.forEach(function (g) { if (g.cuenta) g.apodos.forEach(function (a) { cands.push({ g: g, a: a }); }); });
    cands.sort(function (x, y) { return y.a.length - x.a.length || y.a.join('').length - x.a.join('').length; });
    buscarMarca:
    for (var ci = 0; ci < cands.length; ci++) {
      var a = cands[ci].a;
      for (var s = 0; s + a.length <= n; s++) {
        if (!libres(s, a.length)) continue;
        var ok = true, aprox = false, salto = 0;
        for (var t = 0; t < a.length; t++) {
          // "Zadig y Voltaire", "Dolce and Gabbana": el conector entre palabras de la marca no cuenta.
          while (t > 0 && s + t + salto < n - 1 && /^(y|e|and|n)$/.test(ws[s + t + salto]) && !usada[s + t + salto]) salto++;
          var q = ws[s + t + salto];
          if (q === undefined || usada[s + t + salto]) { ok = false; break; }
          if (q === a[t]) continue;
          if (opciones.prefijo && s + t + salto === n - 1 && q.length >= 2 && a[t].indexOf(q) === 0 && a.length > 1 && t > 0) continue; // "louis vui"
          if (opciones.prefijo && s + t + salto === n - 1 && q.length >= 3 && a[t].indexOf(q) === 0 && a[t].length >= 5 && !ix.vocTodo[q] && !hayPrefijo(ix, q) && marcasQueEmpiezan(ix, q) === 1) continue; // "herm"
          if (!ix.vocTodo[q] && a[t].length >= 5 && parecida(q, a[t])) { aprox = true; continue; }
          ok = false; break;
        }
        if (ok) {
          marca = cands[ci].g;
          viaMarca = aprox ? 'aproximada' : (a.join(' ') === norm(marca.nombre || '') ? 'exacta' : 'apodo');
          rango(s, a.length + salto);
          break buscarMarca;
        }
      }
    }

    // 1b) Mientras se escribe, la última palabra puede ser el comienzo de una marca de dos palabras
    //     ("neceser louis" → Louis Vuitton), salvo que forme un modelo con la anterior ("saint louis").
    if (!marca && opciones.prefijo && n && !usada[n - 1] && !(n >= 2 && ix.bigramas[ws[n - 2] + ' ' + ws[n - 1]])) {
      for (ci = 0; ci < cands.length && !marca; ci++) {
        if (cands[ci].a.length > 1 && cands[ci].a[0] === ws[n - 1]) { marca = cands[ci].g; viaMarca = 'apodo'; usada[n - 1] = true; }
      }
    }

    // 2) Frases del diccionario (la más larga primero): "bolso de viaje", "animal print", "a pedido"…
    ix.frases.forEach(function (fr) {
      if (fr.pal.length < 2) return;
      for (var i = 0; i + fr.pal.length <= n; i++) {
        if (libres(i, fr.pal.length) && coincideFrase(i, fr.pal)) {
          terminos.push(termConcepto(fr.k, ws.slice(i, i + fr.pal.length).join(' '), 'exacta', i));
          rango(i, fr.pal.length);
        }
      }
    });

    // 3) Colecciones de la tienda por nombre ("verano", "más vendidas"…)
    ix.colBuscables.forEach(function (cb) {
      for (var i = 0; i + cb.pal.length <= n; i++) {
        if (libres(i, cb.pal.length) && coincideFrase(i, cb.pal) && !(cb.pal.length === 1 && ix.palabraConcepto[ws[i]])) {
          terminos.push({ q: cb.nombre, clase: 'coleccion', via: 'exacta', pos: i, col: cb.nombre, mostrar: ws.slice(i, i + cb.pal.length).join(' ') });
          rango(i, cb.pal.length);
        }
      }
    });

    // 4) Palabras separadas que en el catálogo van juntas ("lou lou", "neo noe", "on the go").
    for (var i = 0; i < n; i++) {
      if (usada[i]) continue;
      var j3 = ws[i] + (ws[i + 1] || '') + (ws[i + 2] || ''), j2 = ws[i] + (ws[i + 1] || '');
      if (libres(i, 3) && ix.vocModelo[j3] && !ix.vocModelo[ws[i]]) { terminos.push(termLiteral(j3, 'exacta', i)); rango(i, 3); }
      else if (libres(i, 2) && ix.vocModelo[j2] && !(ix.vocTodo[ws[i]] && ix.vocTodo[ws[i + 1]])) { terminos.push(termLiteral(j2, 'exacta', i)); rango(i, 2); }
    }

    // 4b) Dos palabras seguidas que forman un nombre de modelo ("Cap Vert", "Box Suitcase")
    //     van tal cual, aunque cada una sola signifique otra cosa ("cap" = gorra).
    for (i = 0; i + 1 < n; i++) {
      if (!libres(i, 2) || !ix.bigramas[ws[i] + ' ' + ws[i + 1]]) continue;
      if (!ix.palabraConcepto[ws[i]] && !ix.palabraConcepto[ws[i + 1]]) continue; // sin ambigüedad: lo resuelve el paso 5
      terminos.push(termLiteral(ws[i], 'exacta', i)); terminos.push(termLiteral(ws[i + 1], 'exacta', i + 1)); rango(i, 2); i++;
    }

    // 5) Palabras sueltas
    var herrajeCtx = false;
    for (i = 0; i < n; i++) {
      if (usada[i]) continue;
      var w = ws[i], ultima = i === n - 1;
      if (/^herraje|^hardware$|^herrajeria$/.test(w)) { herrajeCtx = true; usada[i] = true; continue; }
      if (ix.vacias[w]) { usada[i] = true; continue; }
      var term = clasificar(w, i, ultima && opciones.prefijo);
      usada[i] = true;
      if (!term) continue;
      if (herrajeCtx && term.clase === 'color') { term.clase = 'herraje'; }
      terminos.push(term);
    }

    function termConcepto(k, original, via, pos) {
      return { q: k.id, clase: k.clase === 'diseno' ? 'diseno' : k.clase, sub: k.sub, concepto: k, via: via, original: original, pos: pos };
    }
    function termLiteral(w, via, pos, original) {
      var clase = TALLES_LITERALES[w] ? 'tamano' : ix.vocModelo[w] ? 'modelo' : ix.vocColorFicha[w] ? 'color' : ix.vocDisenoFicha[w] ? 'diseno' : 'texto';
      return { q: w, clase: clase, literal: true, num: /^\d+$/.test(w), via: via, pos: pos, original: original || w };
    }
    function opcional(t) { t.opcional = true; return t; }
    function significado(w) {
      // Palabra del diccionario. Un color que en el catálogo es nombre de modelo ("Silver", "Golden")
      // y no aparece como color en ninguna ficha se toma como modelo.
      var ks = ix.palabraConcepto[w];
      if (ks && ks.length) {
        var k = ks[0];
        if (k.clase === 'color' && ix.vocModelo[w] && !Object.keys(formas(w)).some(function (x) { return ix.vocColorFicha[x]; })) return { lit: w };
        return { k: k };
      }
      var v = Object.keys(formas(w));
      for (var t = 0; t < v.length; t++) if (ix.vocTexto[v[t]]) return { lit: v[t] };
      return null;
    }
    function clasificar(w, pos, prefijo) {
      // Última palabra a medio escribir y corta o numérica ("chanel 2"): todavía es un prefijo.
      if (prefijo && (w.length < 3 || /^\d+$/.test(w))) {
        var ambitoC = marca && marca.palabras ? marca.palabras : null, hay = 0, unico = null, varios = false;
        Object.keys(ix.vocTodo).forEach(function (k) { if (k.indexOf(w) === 0 && !ix.juntas[k] && (!ambitoC || ambitoC[k])) { hay++; if (unico && unico !== k) varios = true; unico = unico || k; } });
        if (hay && !varios && w.length >= 2) { var su = significado(unico); if (su) return opcional(su.k ? termConcepto(su.k, w, 'prefijo', pos) : termLiteral(su.lit, 'prefijo', pos, w)); }
        if (hay) return { q: w, clase: 'texto', abierto: true, opcional: true, via: 'prefijo', pos: pos, original: w };
        return null;
      }
      var s = significado(w);
      if (s && s.k) {
        var tc = termConcepto(s.k, w, 'exacta', pos);
        // "suitcase", "travel": nombres de modelo que el concepto no cubre; también vale la palabra tal cual.
        if ((s.k.clase === 'categoria' || s.k.clase === 'diseno') && ix.vocModelo[w] &&
            !s.k.reglas.some(function (r) { return r.p.some(function (fr) { return fr.length === 1 && igual(fr[0], w); }); })) tc.tambienLiteral = w;
        return tc;
      }
      if (s && s.lit) return termLiteral(s.lit, 'exacta', pos, w);
      // No existe: completar mientras se escribe, o corregir el error.
      if (prefijo && w.length >= 3) {
        var ambito = marca && marca.palabras ? marca.palabras : null;
        var peso = function (k) { return ambito ? (ambito[k] || 0) : (ix.vocModelo[k] || 0); };
        var elegir = function (aceptar) {
          var mejor = null;
          Object.keys(ix.vocTodo).forEach(function (k) {
            if (!aceptar(k)) return;
            if (ambito && !ambito[k] && !ix.palabraConcepto[k]) return;
            if (!mejor || peso(k) > peso(mejor) || (peso(k) === peso(mejor) && k.length < mejor.length)) mejor = k;
          });
          return mejor;
        };
        // Todas las palabras que empiezan así: si significan lo mismo, se completa; si no, valen todas.
        var sentidosP = {}, primera = null;
        Object.keys(ix.vocTodo).forEach(function (k) {
          if (k.indexOf(w) !== 0 || ix.juntas[k] || (ambito && !ambito[k] && !ix.palabraConcepto[k])) return;
          var sg = significado(k); if (!sg) return;
          sentidosP[sg.k ? 'k:' + sg.k.id : 'l:' + sg.lit] = sg; primera = primera || sg;
        });
        var ns = Object.keys(sentidosP).length;
        if (ns === 1) return opcional(primera.k ? termConcepto(primera.k, w, 'prefijo', pos) : termLiteral(primera.lit, 'prefijo', pos, w));
        if (ns > 1) return { q: w, clase: 'texto', abierto: true, via: 'prefijo', pos: pos, original: w };
        var cand = w.length >= 4 ? elegir(function (k) { return k.length >= w.length && k[0] === w[0] && distancia(w, k.slice(0, w.length), 1) <= 1; }) : null; // "wond" → "wander"
        if (cand) { var sp = significado(cand); if (sp) return opcional(sp.k ? termConcepto(sp.k, w, 'prefijo', pos) : termLiteral(sp.lit, 'prefijo', pos, w)); }
      } else if (prefijo && w.length < 3) {
        return { q: w, clase: 'texto', abierto: true, opcional: true, via: 'prefijo', pos: pos, original: w };
      }
      var porSentido = {}, minimo = 9;
      Object.keys(ix.vocTodo).forEach(function (k) {
        if (!parecida(w, k)) return;
        var sg = significado(k); if (!sg) return;
        var d = distancia(w, k, 2);
        var clave = sg.k ? 'k:' + sg.k.id : 'l:' + sg.lit;
        if (!porSentido[clave] || porSentido[clave].d > d) porSentido[clave] = { sg: sg, palabra: k, d: d };
        if (d < minimo) minimo = d;
      });
      var sentidos = Object.keys(porSentido).filter(function (k) { return porSentido[k].d === minimo; });
      if (sentidos.length === 1) { // un solo significado posible a la menor distancia: se corrige
        var e = porSentido[sentidos[0]];
        if (e.sg.lit) return termLiteral(e.sg.lit, 'aproximada', pos, w);
        var tca = termConcepto(e.sg.k, w, 'aproximada', pos);
        if ((e.sg.k.clase === 'categoria' || e.sg.k.clase === 'diseno') && ix.vocModelo[e.palabra] &&
            !e.sg.k.reglas.some(function (r) { return r.p.some(function (fr) { return fr.length === 1 && igual(fr[0], e.palabra); }); })) tca.tambienLiteral = e.palabra;
        return tca;
      }
      if (prefijo && w.length < 3) return null; // 1 o 2 letras a medio escribir: todavía no cuentan
      return { q: w, clase: 'desconocida', via: 'ninguna', pos: pos, original: w };
    }

    terminos.sort(function (x, y) { return x.pos - y.pos; });
    var reconocidos = terminos.filter(function (t) { return t.clase !== 'desconocida'; });
    return { marca: marca, viaMarca: viaMarca, terminos: terminos, activo: !!(marca || reconocidos.length) };
  }
  function marcasQueEmpiezan(ix, q) {
    var n = 0;
    ix.grupos.forEach(function (g) { if (g.cuenta && g.apodos.some(function (a) { return a.some(function (x) { return x.length >= 5 && x.indexOf(q) === 0; }); })) n++; });
    return n;
  }
  function hayPrefijo(ix, q) { for (var k in ix.vocTodo) if (k.indexOf(q) === 0) return true; return false; }

  /* ¿El producto cumple el término? Devuelve la fuerza (0 = no cumple). */
  function cumple(it, t, ix) {
    if (t.clase === 'desconocida') return 0;
    if (t.clase === 'coleccion') return it.colecciones.indexOf(t.col) !== -1 ? 8 : 0;
    if (t.concepto) {
      var k = t.concepto, lit = t.original && t.original.indexOf(' ') === -1 ? t.original : null;
      var porHerraje = !!(it.conHer && it.conHer[k.id]);
      var ok = t.clase === 'herraje' ? porHerraje : (it.con[k.id] || (k.metal && porHerraje));
      if (!ok && t.tambienLiteral && tienePalabra(it.palForm, t.tambienLiteral)) return 9;
      if (!ok) return 0;
      if (t.clase !== 'herraje' && !it.con[k.id]) return 5; // dorado/plateado solo por los herrajes: después del color
      // Más fuerte si lo escrito aparece tal cual en el producto ("Trainer", "Toilet Pouch").
      if (lit && tienePalabra(it.palForm, lit)) return 10;
      if (!lit && t.original && (' ' + it.titulo.join(' ') + ' ' + it.modelo.join(' ') + ' ').indexOf(' ' + t.original + ' ') !== -1) return 10;
      return t.clase === 'categoria' ? 8 : 6;
    }
    // Palabra a medio escribir en el desplegable: vale cualquier palabra del producto que empiece así.
    if (t.abierto) { for (var pw in it.palabras) if (pw.indexOf(t.q) === 0) return 7; return 0; }
    // Literal (modelo, talle, color o diseño de la ficha, palabra del título)
    if (t.clase === 'herraje') return contiene(it.txt.her, [t.q]) ? 8 : 0;
    if (tienePalabra(it.palForm, t.q)) return it.modelo.some(function (w) { return igual(w, t.q); }) ? 12 : 10;
    return 0;
  }

  function nombreTermino(t, ix) {
    if (t.clase === 'coleccion') return t.mostrar;
    if (t.concepto) {
      var o = t.via === 'exacta' ? t.original : (t.concepto.q[0] || [t.concepto.id]).join(' ');
      return o.split(' ').map(function (w) { return (ix.formas[w] || w).toLowerCase(); }).join(' '); // "marron" → "marrón"
    }
    return ix.formas[t.q] || t.q;
  }
  function frase(l, terms, ix) {
    var partes = [];
    if (l.marca) partes.push(NOMBRE_VISIBLE[norm(l.marca.nombre)] || l.marca.nombre);
    terms.forEach(function (t) { partes.push(t.clase === 'herraje' ? 'herrajes ' + nombreTermino(t, ix) : nombreTermino(t, ix)); });
    return partes.join(' ');
  }

  /* ---------- Búsqueda ---------- */
  function filtrar(l, terms, ix, opciones) {
    var nq = l._nq;
    var pideRegalo = terms.some(function (t) { return t.q === 'regalo'; });
    var out = [], regalos = [];
    var esMarcaSola = !terms.length;
    ix.items.forEach(function (it) {
      if (l.marca && it.grupo !== l.marca) return;
      var puntos = 0, nivel = 1;
      for (var i = 0; i < terms.length; i++) {
        var f = cumple(it, terms[i], ix);
        if (!f) return;
        puntos += f;
        if (terms[i].via === 'prefijo') nivel = Math.max(nivel, 3);
        if (terms[i].via === 'aproximada') nivel = Math.max(nivel, 4);
      }
      if (l.viaMarca === 'apodo') nivel = Math.max(nivel, 2);
      if (l.viaMarca === 'aproximada') nivel = Math.max(nivel, 4);
      var mods = terms.filter(function (t) { return t.literal && t.clase === 'modelo'; }).map(function (t) { return t.q; });
      if (mods.length > 1 && it.titulo.join(' ').indexOf(mods.join(' ')) !== -1) puntos += 5; // frase en orden
      if (mods.length && it.modelo[0] === mods[0]) puntos += 3;                                // familia de la ficha
      if (terms.length && it.titulo.every(function (w) { return ix.vacias[w] || terms.some(function (t) { return cumple1(it, t, w, ix); }); })) puntos += 20; // título completo
      var fila = { item: it, puntos: puntos, nivel: nivel };
      if (it.tipo === 'bolsas de regalo' && !pideRegalo) { if (opciones.regalos === 'final' && (esMarcaSola || terms.length)) regalos.push(fila); return; }
      out.push(fila);
    });
    var orden = function (a, b) {
      return a.nivel - b.nivel || b.puntos - a.puntos ||
        ((b.item.p.d && !b.item.pedido ? 2 : b.item.p.d ? 1 : 0) - (a.item.p.d && !a.item.pedido ? 2 : a.item.p.d ? 1 : 0)) ||
        (a.item.p.o || 0) - (b.item.p.o || 0) || a.item.idx - b.item.idx;
    };
    out.sort(orden);
    if (out.length) out = out.concat(regalos.sort(orden)); // bolsas de regalo al final, como hoy
    return out;
  }
  // ¿La palabra w del título está pedida por el término t?
  function cumple1(it, t, w, ix) {
    if (t.literal) return igual(w, t.q);
    if (t.concepto) return t.concepto.reglas.some(function (r) { return r.p.some(function (fr) { return fr.length === 1 && igual(w, fr[0]); }); }) || (t.original && igual(w, t.original));
    return false;
  }

  function buscar(consulta, ix, opciones) {
    opciones = opciones || {};
    var l = leer(consulta, ix, opciones);
    l._nq = norm(consulta);
    var res = { consulta: consulta, lectura: l, productos: [], aviso: null, corregido: null, alternativa: null, marca: l.marca ? l.marca.nombre : null, marcaVisible: l.marca ? (NOMBRE_VISIBLE[norm(l.marca.nombre)] || l.marca.nombre) : null };
    if (!l.activo) return res;

    var terms = l.terminos;
    if (terms.some(function (t) { return t.via === 'aproximada'; }) || l.viaMarca === 'aproximada') {
      res.corregido = frase(l, terms.filter(function (t) { return t.clase !== 'desconocida'; }), ix);
    }
    var out = filtrar(l, terms, ix, opciones);
    if (!out.length && terms.some(function (t) { return t.opcional; })) {
      terms = terms.filter(function (t) { return !t.opcional; }); l.terminos = terms;
      out = (terms.length || l.marca) ? filtrar(l, terms, ix, opciones) : [];
    }

    // Nada cumple todo: la alternativa más cercana, dicha con claridad.
    if (!out.length && terms.length) {
      var mejor = null;
      var n = terms.length;
      var costoDe = function (t) { return t.num && !ix.inicioModelo[t.q] ? PRIORIDAD_SOLTAR.tamano : (PRIORIDAD_SOLTAR[t.clase] || 0); };
      for (var cuantas = 1; cuantas < n && !mejor; cuantas++) {
        combinaciones(n, cuantas).forEach(function (sacar) {
          var quedan = terms.filter(function (t, i) { return sacar.indexOf(i) === -1; });
          // Tiene que quedar algo más que la marca (nunca la marca entera mezclada).
          if (!quedan.length || !(l.marca || quedan.some(function (t) { return t.clase === 'modelo' || t.clase === 'categoria' || t.clase === 'diseno' || t.clase === 'coleccion'; }))) return;
          if (quedan.some(function (t) { return t.clase === 'desconocida'; })) return;
          var costo = sacar.reduce(function (s, i) { return s + costoDe(terms[i]); }, 0);
          if (mejor && mejor.costo <= costo) return;
          var r = filtrar(l, quedan, ix, opciones);
          if (r.length) mejor = { costo: costo, marca: l.marca, quedan: quedan, sacadas: sacar.map(function (i) { return terms[i]; }), out: r };
        });
      }
      // El modelo existe pero en otra marca ("Gucci Birkin" → las Birkin de Hermès).
      var conocidos = terms.filter(function (t) { return t.clase !== 'desconocida'; });
      if (!mejor && l.marca && !opciones.prefijo && conocidos.some(function (t) { return (t.clase === 'modelo' && !t.num) || t.clase === 'categoria' || t.clase === 'diseno'; })) {
        var sinMarca = { marca: null, viaMarca: null, terminos: conocidos };
        var r2 = filtrar(sinMarca, conocidos, ix, opciones);
        if (r2.length) mejor = { marca: null, quedan: conocidos, sacadas: [], out: r2, otraMarca: true };
      }
      if (mejor) {
        out = mejor.out;
        res.alternativa = {
          pedido: frase(l, conocidos, ix),
          mostrado: frase({ marca: mejor.marca }, mejor.quedan, ix),
          faltan: mejor.otraMarca ? [NOMBRE_VISIBLE[norm(l.marca.nombre)] || l.marca.nombre] : mejor.sacadas.map(function (t) { return t.original || nombreTermino(t, ix); }),
          otraMarca: !!mejor.otraMarca
        };
      }
    }
    if (!out.length) res.aviso = 'sin-resultados';
    else if (res.alternativa) res.aviso = 'alternativa';
    res.productos = out.map(function (x) { return { h: x.item.p.h, t: x.item.p.t, nivel: x.nivel, exacto: !res.alternativa, p: x.item.p, puntos: x.puntos }; });
    return res;
  }
  // Todas las formas de elegir k índices de n, prefiriendo soltar primero lo menos importante.
  function combinaciones(n, k) {
    var out = [];
    (function rec(desde, acc) {
      if (acc.length === k) { out.push(acc.slice()); return; }
      for (var i = desde; i < n; i++) { acc.push(i); rec(i + 1, acc); acc.pop(); }
    })(0, []);
    return out;
  }

  /* ¿Esta consulta la resuelve el buscador inteligente? */
  function reconoce(consulta, ix, opciones) {
    var r = buscar(consulta, ix, opciones);
    return !!(r.lectura.activo && (r.productos.length || r.lectura.marca || r.lectura.terminos.some(function (t) { return t.clase !== 'desconocida' && t.clase !== 'texto'; })));
  }

  var api = { norm: norm, construir: construir, leer: leer, buscar: buscar, reconoce: reconoce, distancia: distancia, formas: formas, APODOS_MARCA: APODOS_MARCA, CONCEPTOS: C, version: 2 };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ToucheMotor = api;
})(typeof window !== 'undefined' ? window : this);
/* Touché · Buscador inteligente: página /search y buscador desplegable
   -------------------------------------------------------------------
   - Lee el índice del catálogo publicado (/search?view=modelos), lo guarda
     10 minutos en la sesión y arma el motor de arriba.
   - En /search: si la búsqueda nombra algo que el catálogo conoce (marca,
     modelo, categoría, material, color, tamaño…), reemplaza los resultados
     de Shopify por los del motor, con las mismas tarjetas
     (sections/touche-modelos-tarjetas), la misma grilla, contador, orden,
     filtros y paginación del tema. Si no reconoce nada, no hace nada.
   - En el desplegable: reemplaza la lista de productos por la del modelo
     (sections/touche-modelos-predictivo), con el mismo HTML del tema.
   - Expone window.ToucheModelosListo para que assets/touche-busqueda.js no
     corrija ni redirija las búsquedas que ya resuelve esta capa. */
(function () {
  'use strict';
  var M = window.ToucheMotor;
  if (!M || typeof document === 'undefined') return;

  var CLAVE = 'touche_modelos_indice_v2';
  var DURACION = 10 * 60 * 1000;
  var POR_PEDIDO = 20;
  var raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var html = document.documentElement;

  function listo() { html.classList.remove('touche-modelo-pendiente'); }
  /* ¿La búsqueda la resuelve el motor? (si no reconoce nada, queda la de Shopify) */
  function usar(r) {
    var l = r.lectura;
    return !!(l.activo && (r.productos.length || l.marca || l.terminos.some(function (t) { return t.clase !== 'desconocida' && t.clase !== 'texto'; })));
  }

  /* ---------- Índice ---------- */
  var indicePromesa = null;
  function pedirPagina(n) {
    return fetch(raiz + '/search?view=modelos&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('indice ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); });
  }
  function cargarIndice() {
    if (indicePromesa) return indicePromesa;
    indicePromesa = new Promise(function (resolve, reject) {
      try {
        var c = JSON.parse(sessionStorage.getItem(CLAVE) || 'null');
        if (c && Date.now() - c.t < DURACION && c.productos && c.productos.length) { resolve(c.productos); return; }
      } catch (e) {}
      pedirPagina(1).then(function (primera) {
        var resto = [];
        for (var n = 2; n <= Math.min(primera.p || 1, 40); n++) resto.push(pedirPagina(n));
        return Promise.all(resto).then(function (otras) {
          var productos = [];
          [primera].concat(otras).forEach(function (pag) {
            (pag.productos || []).forEach(function (p, i) { p.o = (pag.o || 0) + i; productos.push(p); });
          });
          try { sessionStorage.setItem(CLAVE, JSON.stringify({ t: Date.now(), productos: productos })); } catch (e) {}
          resolve(productos);
        });
      }).catch(reject);
    });
    indicePromesa.catch(function () { indicePromesa = null; });
    return indicePromesa;
  }
  var motorPromesa = null;
  function motor() {
    if (!motorPromesa) {
      motorPromesa = cargarIndice().then(function (productos) { return M.construir(productos); });
      motorPromesa.catch(function () { motorPromesa = null; });
    }
    return motorPromesa;
  }
  // Para assets/touche-busqueda.js (se carga recién cuando alguien lo pide).
  window.ToucheModelosListo = {
    then: function (ok, mal) {
      return motor().then(function (ix) {
        return { reconoce: function (q, opc) { return M.reconoce(q, ix, opc); } };
      }).then(ok, mal);
    }
  };
  window.ToucheModelos = { buscar: function (q, opc) { return motor().then(function (ix) { return M.buscar(q, ix, opc || { regalos: 'final' }); }); } };

  /* ---------- Utilidades ---------- */
  function hacer(htmlTexto) { var t = document.createElement('template'); t.innerHTML = htmlTexto; return t.content; }
  function escapar(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pedirSeccion(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
  }
  function enLotes(lista, n) { var out = []; for (var i = 0; i < lista.length; i += n) out.push(lista.slice(i, i + n)); return out; }

  /* Tarjetas (grilla y desplegable), guardadas por producto. */
  var cacheTarjetas = { 'touche-modelos-tarjetas': {}, 'touche-modelos-predictivo': {} };
  var cacheGrupo = null;
  function pedirTarjetas(handles, seccion, desde) {
    var cache = cacheTarjetas[seccion];
    var faltan = handles.filter(function (h) { return !cache[h]; });
    var pedidos = enLotes(faltan, POR_PEDIDO).map(function (lote, i) {
      var q = (seccion === 'touche-modelos-tarjetas' ? ['touche-desde-' + ((desde || 0) + i * POR_PEDIDO)] : []).concat(lote).join(' ');
      return pedirSeccion(raiz + '/search?q=' + encodeURIComponent(q) + '&section_id=' + seccion).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        doc.querySelectorAll('[data-touche-h]').forEach(function (el) { cache[el.getAttribute('data-touche-h')] = el.outerHTML; });
        if (seccion === 'touche-modelos-predictivo' && !cacheGrupo) {
          var g = doc.querySelector('[data-touche-modelos-grupo]');
          if (g) { g.querySelector('ul').innerHTML = ''; cacheGrupo = g.outerHTML; }
        }
      });
    });
    return Promise.all(pedidos).then(function () {
      return handles.filter(function (h) { return cache[h]; }).map(function (h) { return cache[h]; });
    });
  }

  /* Molde de filtros y textos de la tienda. */
  var moldePromesa = null;
  function molde() {
    if (!moldePromesa) {
      moldePromesa = pedirSeccion(raiz + '/collections/all?section_id=touche-modelos-filtros').then(function (t) {
        return new DOMParser().parseFromString(t, 'text/html');
      });
      moldePromesa.catch(function () { moldePromesa = null; });
    }
    return moldePromesa;
  }
  function textos(doc) {
    var el = doc.querySelector('[data-touche-textos]');
    var d = el ? el.dataset : {};
    return {
      contar: function (n) { return n === 1 ? (d.uno || '1 resultado').trim() : (d.varios || '7777 resultados').replace('7777', n).trim(); },
      pagina: function (n) { return (d.pagina || 'Página 7777').replace('7777', n); },
      anterior: d.anterior || 'Anterior', siguiente: d.siguiente || 'Siguiente', paginacion: d.paginacion || 'Paginación',
      quitar: function (l) { return (d.quitar || 'Quitar __TOUCHE__').replace('__TOUCHE__', l); },
      limpiarFiltro: d.limpiarFiltro || '',
      moneda: d.moneda || '${{amount}}',
      icono: el && el.querySelector('[data-icono-cerrar]') ? el.querySelector('[data-icono-cerrar]').innerHTML : ''
    };
  }
  function dinero(centavos, formato) {
    var n = Number(centavos) / 100;
    function fmt(dec, mil, sepDec) {
      var p = n.toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil) + (dec ? sepDec + p[1] : '');
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        default: return fmt(2, ',', '.');
      }
    });
  }

  /* ---------- Página de resultados ---------- */
  var estado = null;

  function leerFiltros(params) {
    var f = { vendor: params.getAll('filter.p.vendor'), tipo: params.getAll('filter.p.product_type'), entrega: params.getAll('filter.p.m.custom.entrega'),
      desde: params.get('filter.v.price.gte'), hasta: params.get('filter.v.price.lte'), orden: params.get('sort_by') || 'relevance',
      pagina: Math.max(1, parseInt(params.get('page') || '1', 10) || 1) };
    f.desde = f.desde === null || f.desde === '' ? null : Number(String(f.desde).replace(/\./g, '').replace(',', '.'));
    f.hasta = f.hasta === null || f.hasta === '' ? null : Number(String(f.hasta).replace(/\./g, '').replace(',', '.'));
    return f;
  }
  function filtrar(lista, f) {
    return lista.filter(function (x) {
      var p = x.p;
      if (f.vendor.length && f.vendor.indexOf(p.v) === -1) return false;
      if (f.tipo.length && f.tipo.indexOf(p.y) === -1) return false;
      if (f.entrega.length && f.entrega.indexOf(p.e) === -1) return false;
      if (f.desde !== null && p.p / 100 < f.desde) return false;
      if (f.hasta !== null && p.p / 100 > f.hasta) return false;
      return true;
    });
  }
  function ordenar(lista, orden) {
    var l = lista.map(function (x, i) { return { x: x, i: i }; });
    if (orden === 'price-ascending') l.sort(function (a, b) { return a.x.p.p - b.x.p.p || a.i - b.i; });
    else if (orden === 'price-descending') l.sort(function (a, b) { return b.x.p.p - a.x.p.p || a.i - b.i; });
    return l.map(function (o) { return o.x; });
  }
  function urlCon(params, cambios) {
    var p = new URLSearchParams(params.toString());
    Object.keys(cambios).forEach(function (k) {
      var v = cambios[k];
      if (Array.isArray(v)) { p.delete(k); v.forEach(function (x) { p.append(k, x); }); }
      else if (v === null) p.delete(k); else p.set(k, v);
    });
    return '?' + p.toString();
  }

  /* Filtros: el HTML exacto del tema, con solo las opciones que tienen los productos del modelo. */
  function armarFiltros(doc, base, f, saltar) {
    var conjuntos = {
      'filter.p.vendor': {}, 'filter.p.product_type': {}, 'filter.p.m.custom.entrega': {}
    };
    var activos = { 'filter.p.vendor': f.vendor, 'filter.p.product_type': f.tipo, 'filter.p.m.custom.entrega': f.entrega };
    var maxPrecio = 0;
    base.forEach(function (x) {
      conjuntos['filter.p.vendor'][x.p.v] = 1;
      if (x.p.y) conjuntos['filter.p.product_type'][x.p.y] = 1;
      if (x.p.e) conjuntos['filter.p.m.custom.entrega'][x.p.e] = 1;
      if (x.p.p > maxPrecio) maxPrecio = x.p.p;
    });
    var bloques = [];
    doc.querySelectorAll('[data-touche-filtros] #FacetFiltersForm .js-filter').forEach(function (orig) {
      var b = orig.cloneNode(true);
      var precio = b.querySelector('price-range');
      var casillas = b.querySelectorAll('input[type="checkbox"]');
      if (precio) {
        var max = Math.max(1, Math.ceil(maxPrecio / 100));
        var desde = f.desde !== null ? Math.min(f.desde, max) : null, hasta = f.hasta !== null ? Math.min(f.hasta, max) : null;
        precio.setAttribute('data-price-max', max);
        precio.style.setProperty('--price-min', ((desde || 0) / max * 100) + '%');
        precio.style.setProperty('--price-max', ((hasta === null ? max : hasta) / max * 100) + '%');
        var rmin = precio.querySelector('[data-type="min-range"]'), rmax = precio.querySelector('[data-type="max-range"]');
        var imin = precio.querySelector('[data-type="min-input"]'), imax = precio.querySelector('[data-type="max-input"]');
        if (rmin) { rmin.setAttribute('max', max); rmin.setAttribute('value', desde || 0); }
        if (rmax) { rmax.setAttribute('max', max); rmax.setAttribute('value', hasta === null ? max : hasta); }
        if (imin) { imin.setAttribute('max', Math.max(0, (hasta === null ? max : hasta) - 5)); if (desde !== null) imin.setAttribute('value', desde); else imin.removeAttribute('value'); }
        var conDecimales = imax && (imax.getAttribute('placeholder') || '').indexOf('.') !== -1;
        if (imax) { imax.setAttribute('max', max); imax.setAttribute('placeholder', conDecimales ? max + '.00' : max); imax.setAttribute('min', (desde || 0) + 5); if (hasta !== null) imax.setAttribute('value', hasta); else imax.removeAttribute('value'); }
        if (desde !== null || hasta !== null) abrir(b);
      } else if (casillas.length) {
        var nombre = casillas[0].name;
        if (!conjuntos[nombre]) return; // filtro que esta capa no sabe aplicar: no se muestra
        var quedan = 0;
        b.querySelectorAll('li.f-facets__item').forEach(function (li) {
          var inp = li.querySelector('input[type="checkbox"]');
          if (!inp || !conjuntos[nombre][inp.value]) { li.remove(); return; }
          quedan++;
          inp.removeAttribute('disabled');
          var lab = li.querySelector('.f-checkbox'); if (lab) lab.classList.remove('f-checkbox--disabled');
          if (activos[nombre].indexOf(inp.value) !== -1) { inp.setAttribute('checked', ''); abrir(b); } else inp.removeAttribute('checked');
          li.classList.toggle('show-more-item', quedan > 10);
          li.classList.toggle('hidden', quedan > 10);
        });
        if (!quedan) return;
        if (quedan <= 10) { var mas = b.querySelector('show-more-button'); if (mas) mas.remove(); }
      } else return;
      bloques.push(b);
    });
    bloques.forEach(function (b, i) {
      b.setAttribute('data-index', i + 1);
      var tab = b.querySelector('collapsible-tab');
      if (i === 0 && tab) abrir(b);
    });
    var cont = document.querySelector('#FacetFiltersForm .f-facets__blocks');
    if (!cont) return;
    var viejos = {};
    cont.querySelectorAll(':scope > .js-filter').forEach(function (v) { viejos[v.getAttribute('data-index')] = v; });
    var frag = document.createDocumentFragment();
    bloques.forEach(function (b) {
      var idx = b.getAttribute('data-index');
      frag.appendChild(saltar && viejos[idx] && idx === saltar ? viejos[idx] : document.importNode(b, true));
    });
    cont.replaceChildren(frag);
  }
  function abrir(b) {
    var tab = b.querySelector('collapsible-tab');
    if (tab) tab.setAttribute('open', 'true');
    var c = b.querySelector('[data-content]'); if (c) c.removeAttribute('hidden');
  }

  /* Chips de filtros activos, con el mismo HTML de snippets/product-grid-header.liquid. */
  function armarActivos(params, f, tx, doc) {
    var cont = document.querySelector('.active-facets');
    if (!cont) return;
    var limpiar = cont.querySelector('.active-facets__button-clear');
    var limpiarEl = limpiar ? limpiar.closest('facet-remove') : null;
    var etiquetas = {};
    doc.querySelectorAll('[data-touche-filtros] input[type="checkbox"]').forEach(function (i) {
      var lab = i.closest('label'); etiquetas[i.name + '|' + i.value] = lab ? lab.textContent.replace(/\s+/g, ' ').trim() : i.value;
    });
    var chips = '';
    [['filter.p.vendor', f.vendor], ['filter.p.product_type', f.tipo], ['filter.p.m.custom.entrega', f.entrega]].forEach(function (par) {
      par[1].forEach(function (v) {
        var cambio = {}; cambio[par[0]] = par[1].filter(function (x) { return x !== v; }); cambio.page = null;
        var lab = etiquetas[par[0] + '|' + v] || v;
        chips += '<facet-remove><a href="' + escapar(urlCon(params, cambio)) + '" class="active-facets__button btn btn--small" data-tippy-content="' + escapar(tx.quitar(lab)) + '" data-tippy-theme="color-background-1" data-tippy-placement="top"><span class="active-facets__button-inner">' + escapar(lab) + tx.icono + '</span></a></facet-remove>';
      });
    });
    if (f.desde !== null || f.hasta !== null) {
      var max = Math.ceil(Math.max.apply(null, estado.base.map(function (x) { return x.p.p; }).concat([0])) / 100);
      chips += '<facet-remove><a href="' + escapar(urlCon(params, { 'filter.v.price.gte': null, 'filter.v.price.lte': null, page: null })) + '" class="active-facets__button btn btn--small"><span class="active-facets__button-inner">' +
        escapar(dinero((f.desde || 0) * 100, tx.moneda)) + ' -' + escapar(dinero((f.hasta === null ? max : f.hasta) * 100, tx.moneda)) + tx.icono +
        '<span class="visually-hidden">' + escapar(tx.limpiarFiltro) + '</span></span></a></facet-remove>';
    }
    cont.replaceChildren(hacer(chips));
    if (limpiarEl) cont.appendChild(limpiarEl);
  }

  /* Paginación con el mismo HTML de snippets/pagination.liquid. */
  function armarPaginacion(params, actual, total, tx) {
    var lista = document.querySelector('[data-product-container]');
    if (!lista) return;
    var envoltura = lista.querySelector('.f-pagination__wrapper');
    if (total <= 1) { if (envoltura) envoltura.remove(); return; }
    var flechaIzq = '<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 1.25L0.75 5L4.5 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var flechaDer = '<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.25L5.25 5L1.5 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var url = function (n) { return escapar(urlCon(params, { page: n === 1 ? null : String(n) })); };
    var partes = [];
    for (var n = 1; n <= total; n++) {
      if (n === 1 || n === total || Math.abs(n - actual) <= 2) partes.push(n);
      else if (partes[partes.length - 1] !== '…') partes.push('…');
    }
    var h = '<nav class="f-pagination flex justify-center" role="navigation" aria-label="' + escapar(tx.paginacion) + '"><ul class="f-pagination__list list-none" role="list">';
    if (actual > 1) h += '<li><a href="' + url(actual - 1) + '" class="f-pagination__item f-pagination__item--prev" aria-label="' + escapar(tx.anterior) + '">' + flechaIzq + '<span>' + escapar(tx.anterior) + '</span></a></li>';
    partes.forEach(function (p) {
      if (p === '…') h += '<li><span class="f-pagination__item">…</span></li>';
      else if (p === actual) h += '<li><span class="f-pagination__item f-pagination__item--current" aria-current="page" aria-label="' + escapar(tx.pagina(p)) + '">' + p + '</span></li>';
      else h += '<li><a href="' + url(p) + '" class="f-pagination__item" aria-label="' + escapar(tx.pagina(p)) + '">' + p + '</a></li>';
    });
    if (actual < total) h += '<li><a href="' + url(actual + 1) + '" class="f-pagination__item f-pagination__item--next" aria-label="' + escapar(tx.siguiente) + '"><span>' + escapar(tx.siguiente) + '</span>' + flechaDer + '</a></li>';
    h += '</ul></nav>';
    if (!envoltura) { envoltura = document.createElement('div'); envoltura.className = 'f-pagination__wrapper text-center'; lista.appendChild(envoltura); }
    envoltura.innerHTML = h;
  }

  function dibujar(cadena, evento) {
    var params = new URLSearchParams(cadena);
    if (!params.get('q')) params.set('q', estado.q);
    var f = leerFiltros(params);
    return molde().then(function (doc) {
      var tx = textos(doc);
      var lista = ordenar(filtrar(estado.base, f), f.orden);
      var limite = estado.limite;
      var paginas = Math.max(1, Math.ceil(lista.length / limite));
      var actual = Math.min(f.pagina, paginas);
      var desde = (actual - 1) * limite;
      var handles = lista.slice(desde, desde + limite).map(function (x) { return x.h; });
      var saltar = evento && evento.target && evento.target.closest ? (evento.target.closest('.js-filter') || {}).dataset : null;
      armarFiltros(doc, estado.base, f, saltar ? saltar.index : null);
      armarActivos(params, f, tx, doc);
      document.querySelectorAll('[data-product-count]').forEach(function (el) { el.textContent = tx.contar(lista.length); });
      document.title = titulo(document.title, lista.length);
      var orden = document.getElementById('SortBy'); if (orden) orden.value = f.orden;
      armarPaginacion(params, actual, paginas, tx);
      return pedirTarjetas(handles, 'touche-modelos-tarjetas', desde).then(function (tarjetas) {
        var grilla = document.getElementById('product-grid');
        if (grilla) grilla.replaceChildren(hacer(tarjetas.join('')));
        if (typeof window.__reInitTooltip === 'function') { try { __reInitTooltip(document.querySelector('.active-facets')); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('collection:rerendered'));
      });
    });
  }

  function engancharFiltros() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__touche) return;
    var original = FacetFiltersForm.renderPage;
    FacetFiltersForm.__touche = true;
    if (!FacetFiltersForm.section) FacetFiltersForm.section = document.getElementById('ProductGridContainer');
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      if (!estado) return original.apply(this, arguments);
      if (updateURLHash === undefined) updateURLHash = true;
      FacetFiltersForm.searchParamsPrev = searchParams;
      dibujar(searchParams, event).catch(function () {}).then(function () {
        if (FacetFiltersForm.loading && FacetFiltersForm.loading.finish) FacetFiltersForm.loading.finish();
      });
      var s = FacetFiltersForm.section || document.getElementById('ProductGridContainer');
      if (s) window.scroll({ top: s.offsetTop - 100, left: 0, behavior: 'smooth' });
      if (updateURLHash) history.pushState({ searchParams: searchParams }, '', location.pathname + (searchParams ? '?' + searchParams : ''));
    };
  }

  function encabezadoCajon(doc) {
    // Cuando Shopify no devolvió resultados, el cajón de filtros del celular viene sin encabezado.
    var cajon = document.querySelector('#Drawer-Facets .f-drawer__content');
    if (!cajon || cajon.querySelector('.f-facets__header')) return;
    var enc = doc.querySelector('[data-touche-filtros] .f-facets__header');
    if (!enc) return;
    var nuevo = document.importNode(enc, true);
    cajon.insertBefore(nuevo, cajon.firstChild);
    var cerrar = nuevo.querySelector('.f-drawer__close');
    var drawer = cajon.closest('drawer-component');
    if (cerrar && drawer) cerrar.addEventListener('click', function (e) { e.preventDefault(); drawer.closeDrawer && drawer.closeDrawer(false); });
  }

  function titulo(t, n) {
    return t.replace(/\d+\s+resultados?\s+encontrados?/, n === 1 ? '1 resultado encontrado' : n + ' resultados encontrados');
  }

  function aviso(htmlTexto) {
    var el = document.getElementById('ToucheBusquedaAviso');
    if (!el) return;
    el.innerHTML = htmlTexto;
    el.hidden = false;
  }

  /* Nada cumple todo lo pedido: se dice qué se muestra en su lugar. */
  function textoAlternativa(q, r) {
    var a = r.alternativa;
    if (a.otraMarca) return 'No hay productos de ' + escapar(a.faltan[0]) + ' que coincidan con “' + escapar(q) + '”. Te mostramos <strong>“' + escapar(a.mostrado) + '”</strong> de otras marcas.';
    return 'No hay productos publicados que coincidan con todo “' + escapar(q) + '”. Te mostramos <strong>“' + escapar(a.mostrado) + '”</strong>.';
  }

  function paginaBusqueda() {
    var dato = document.getElementById('ToucheBusqueda');
    if (!dato) { listo(); return; }
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) { listo(); return; }
    motor().then(function (ix) {
      var r = M.buscar(q, ix, { regalos: 'final' });
      if (!usar(r)) { listo(); return; } // no reconoce nada: queda la búsqueda de siempre
      var plantilla = document.querySelector('.f-template-search');
      var grilla = document.getElementById('ProductGridContainer');
      var sinRes = document.querySelectorAll('.touche-sin-resultados');
      html.classList.add('touche-modelo');
      if (!r.productos.length) {
        if (grilla) grilla.classList.add('touche-oculto');
        sinRes.forEach(function (el) { el.classList.remove('touche-oculto'); });
        if (plantilla) plantilla.classList.add('f-template-search--empty');
        var texto = r.marca
          ? 'Hoy no tenemos productos de “' + escapar(q) + '” publicados. <a href="' + raiz + '/collections/all?filter.p.vendor=' + encodeURIComponent(r.marca) + '">Ver todo ' + escapar(r.marcaVisible || r.marca) + '</a>'
          : 'Hoy no tenemos productos de “' + escapar(q) + '” publicados.';
        aviso(texto);
        document.title = titulo(document.title, 0);
        listo();
        return;
      }
      estado = { q: q, base: r.productos, limite: parseInt(dato.getAttribute('data-limite') || '24', 10) || 24 };
      if (grilla) grilla.classList.remove('touche-oculto');
      sinRes.forEach(function (el) { el.classList.add('touche-oculto'); });
      if (plantilla) plantilla.classList.remove('f-template-search--empty');
      if (r.alternativa) aviso(textoAlternativa(q, r));
      else if (r.corregido) aviso('Mostramos resultados para <strong>“' + escapar(r.corregido) + '”</strong>.');
      engancharFiltros();
      molde().then(encabezadoCajon).catch(function () {});
      dibujar(location.search.slice(1)).catch(function () {}).then(listo);
    }).catch(listo);
  }

  /* ---------- Buscador desplegable ---------- */
  function revisarDesplegable() {
    document.querySelectorAll('#f-predictive-search-results[data-touche-terms]:not([data-touche-modelos])').forEach(function (cont) {
      cont.setAttribute('data-touche-modelos', '');
      var q = cont.getAttribute('data-touche-terms') || '';
      if (!q.trim()) return;
      motor().then(function (ix) {
        var r = M.buscar(q, ix, { prefijo: true });
        if (!usar(r) || !cont.isConnected) return;
        var grupo = cont.querySelector('.f-predictive-search__result-products');
        var conteo = cont.parentNode ? cont.parentNode.querySelector('[data-predictive-search-live-region-count-value]') : null;
        if (!r.productos.length) {
          if (grupo) grupo.remove();
          var caja = cont.querySelector('[data-touche-sugerencia]');
          if (caja) {
            caja.textContent = 'Hoy no tenemos productos de “' + q + '” publicados.';
            caja.hidden = false;
          }
          return;
        }
        var handles = r.productos.slice(0, 10).map(function (x) { return x.h; });
        var nota = cont.querySelector('[data-touche-sugerencia]');
        if (nota && r.alternativa) { nota.textContent = 'No hay coincidencias con todo “' + q + '”. Te mostramos “' + r.alternativa.mostrado + '”.'; nota.hidden = false; }
        pedirTarjetas(handles, 'touche-modelos-predictivo').then(function (items) {
          if (!cont.isConnected || !cacheGrupo) return;
          var nuevo = hacer(cacheGrupo).firstElementChild;
          nuevo.querySelector('ul').innerHTML = items.join('');
          nuevo.querySelectorAll('li[role="option"]').forEach(function (li, i) { li.id = 'f-predictive-search-option-' + (i + 1); });
          if (grupo) grupo.replaceWith(nuevo);
          else {
            var antes = cont.querySelector('.f-predictive-search__result-group:not(.f-predictive-search__result-seggestions)') || cont.querySelector('.f-predictive-search__loading-state');
            cont.insertBefore(nuevo, antes || null);
          }
          if (conteo) conteo.textContent = r.productos.length + ' resultados';
        }).catch(function () {});
      }).catch(function () {});
    });
  }

  function iniciar() {
    paginaBusqueda();
    revisarDesplegable();
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      setTimeout(function () { pendiente = false; revisarDesplegable(); }, 30);
    }).observe(document.body, { childList: true, subtree: true });
    // Precarga del índice al tocar cualquier buscador.
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name="q"]')) motor().catch(function () {});
    });
  }
  // Arranca cuando el tema ya cargó sus scripts (facets.js define los filtros recién ahí).
  var arranco = false;
  function arrancar() { if (arranco) return; arranco = true; iniciar(); }
  if (document.readyState === 'complete') arrancar();
  else { document.addEventListener('DOMContentLoaded', arrancar); window.addEventListener('load', arrancar); }
})();
